import { useContext, useMemo } from 'react';
import { InputComponent, type InputProps } from '@src/components/input/Input.tsx';
import { ReactflowInstanceContext } from '@src/scenario-editor/ScenarioEditor';
import { reactFlowInstanceAtom } from '@src/atoms';
import { findCollidingQuestionIds } from '@src/components/node-info/utils/findCollidingQuestionIds';

export const QuestionIdField = (props: InputProps): JSX.Element => {
  const reactFlowInstance = useContext(ReactflowInstanceContext);
  const instance = reactFlowInstance.get(reactFlowInstanceAtom);
  const nodes = instance?.getNodes() ?? [];

  const collidingQuestionIds = useMemo(() => findCollidingQuestionIds(nodes), [nodes]);

  const value = (props.value ?? '') as string;
  const hasCollision = value.length > 0 && collidingQuestionIds.has(value);

  return (
    <div>
      <InputComponent {...props} />
      {hasCollision && (
        <div
          role="alert"
          className="mt-1 text-xs text-amber-600"
        >
          ⚠ This Question ID is used by another node in this scenario.
        </div>
      )}
    </div>
  );
};
